import { Action, Dispatch } from "redux";
import { PAGE_TYPE } from "../pages/page.types";
import fetchContentByRoute from "../helpers/fetchContentByRoute";
import isBrowserContext from "helpers/isBrowserContext";

export const TRANSITION_PAGE = "TRANSITION_PAGE";
export const UPDATE_PAGE = "UPDATE_PAGE";

export interface TransitionPageAction extends Action {
    type: typeof TRANSITION_PAGE;
    viewState: string;
}

export interface UpdatePageAction extends Action {
    type: typeof UPDATE_PAGE;
    viewState: string;
    content: PAGE_TYPE;
    statusCode: number;
    redirectUrl?: string;
}

export const thunkUpdatePage = (url: string, history: any) => async (dispatch: Dispatch): Promise<void> => {
    try {
        if (!url) {
            throw new Error();
        }

        // Only fire on subsequent requests
        if (isBrowserContext() && history.action === "PUSH") {
            dispatch({
                type: TRANSITION_PAGE,
                viewState: "TRANSITION"
            } as TransitionPageAction);
        }

        const pageRequest = fetchContentByRoute(url);

        const pageResponse = await pageRequest;

        if (isBrowserContext()) {
            setTimeout(async () => {
                if (pageResponse && pageResponse.result) {
                    if (pageResponse.result.umbracoRedirect && typeof (window) !== "undefined") {
                        // TODO: Test if working
                        window.location.href = pageResponse.result.umbracoRedirect;
                    }
                    else {
                        const action: UpdatePageAction = {
                            type: UPDATE_PAGE,
                            viewState: "DONE",
                            content: pageResponse.result,
                            statusCode: pageResponse.statusCode,
                            redirectUrl: pageResponse.result.umbracoRedirect
                        };

                        if (isBrowserContext() && history) {
                            history.replace({
                                pathname: history.location?.pathname,
                                search: history.location?.search,
                                hash: history.location?.hash,
                                state: {
                                    ...history.location?.state,
                                    page: pageResponse.result
                                }
                            });
                        }

                        dispatch(action);
                    }
                }
                // NOTE: The <Transition /> component is responsible to "DONE" the state.
            }, (2000 / 2)); // TODO: Make time dynamic per site
        }
        else {
            if (pageResponse && pageResponse.result) {
                if (pageResponse.result.umbracoRedirect && typeof (window) !== "undefined") {
                    // TODO: Test if working
                    window.location.href = pageResponse.result.umbracoRedirect;
                }
                else {
                    const action: UpdatePageAction = {
                        type: UPDATE_PAGE,
                        viewState: "DONE",
                        content: pageResponse.result,
                        statusCode: pageResponse.statusCode,
                        redirectUrl: pageResponse.result.umbracoRedirect
                    };

                    if (isBrowserContext() && history) {
                        history.replace({
                            pathname: history.location?.pathname,
                            search: history.location?.search,
                            hash: history.location?.hash,
                            state: {
                                ...history.location?.state,
                                page: pageResponse.result
                            }
                        });
                    }

                    dispatch(action);
                }
            }
        }
    }
    catch {
        // TODO: Retry loading the page every 2 seconds

        const action: UpdatePageAction = {
            type: UPDATE_PAGE,
            viewState: "DONE",
            content: {
                _contentType: "errorPage",
                _name: "500 - An error occured",
                _url: url
            },
            statusCode: 500
        };

        dispatch(action);
    }
};

export type PageAction = TransitionPageAction | UpdatePageAction;
